import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import config from '@plone/volto/registry';

import BlogFolderView from '../../../../components/views/BlogFolderView';
import NewsFolderView from '../../../../components/views/NewsFolderView';

const CSJListingView = ({ content }) => {
  const folderViews = config.settings.contentFolderViews || {};
  const CustomView = folderViews[content?.id];

  if (CustomView) {
    return <CustomView content={content} />;
  }

  return (
    <Container id="page-home">
      <section id="content-core">
        {content.items?.map((item) =>
          item['@type'] === 'Collection' ? (
            <article key={`${item.url}/${item.id}`}>
              <h2>
                <Link to={`${item.url}/${item.id}`} title={item['@type']}>
                  {item.title}
                </Link>
              </h2>
              {item.description && <p>{item.description}</p>}
            </article>
          ) : (
            <article key={item.url}>
              <h2>
                <Link to={item.url} title={item['@type']}>
                  {item.title}
                </Link>
              </h2>
              {item.description && <p>{item.description}</p>}
            </article>
          ),
        )}
      </section>
    </Container>
  );
};

CSJListingView.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default CSJListingView;
